export default {
  name: 'MenuPreview',

  props: {
    buttons: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      activeRootIndex: null
    }
  },

  computed: {
    isEmpty() {
      return !this.buttons || this.buttons.length === 0
    }
  },

  watch: {
    activeRootIndex(index) {
      if (index == null) {
        this.clearSubmenuStyles()
        return
      }
      this.$nextTick(() => {
        this.adjustSubmenuPosition(index)
      })
    }
  },

  methods: {
    hasSubmenu(button) {
      return button.sub_button && button.sub_button.length > 0
    },

    closeSubmenu() {
      this.activeRootIndex = null
    },

    onScreenClick() {
      this.closeSubmenu()
    },

    onMenuItemClick(index, event) {
      if (!this.hasSubmenu(this.buttons[index])) {
        return
      }
      event.preventDefault()
      event.stopPropagation()
      this.activeRootIndex = this.activeRootIndex === index ? null : index
    },

    getRefNode(ref) {
      const target = this.$refs[ref]
      if (!target) {
        return null
      }
      return Array.isArray(target) ? target[0] : target
    },

    clearSubmenuStyles() {
      this.buttons.forEach((_, i) => {
        const submenuEl = this.getRefNode(`submenu${i}`)
        if (!submenuEl) {
          return
        }
        submenuEl.style.left = ''
        submenuEl.style.right = ''
        submenuEl.style.visibility = ''
      })
    },

    adjustSubmenuPosition(index) {
      const itemEl = this.getRefNode(`menuItem${index}`)
      const submenuEl = this.getRefNode(`submenu${index}`)
      const barEl = this.$el.querySelector('.bottom-bar')

      if (!itemEl || !submenuEl || !barEl || this.activeRootIndex !== index) {
        return
      }

      submenuEl.style.left = ''
      submenuEl.style.right = ''
      submenuEl.style.visibility = 'hidden'

      const wrapperWidth = barEl.offsetWidth
      const itemWidth = itemEl.offsetWidth
      const innerWidth = submenuEl.offsetWidth
      const centerLeft = (itemWidth - innerWidth) / 2

      submenuEl.style.left = `${centerLeft}px`

      const offsetLeft = submenuEl.getBoundingClientRect().left - barEl.getBoundingClientRect().left
      const elementOffset = itemEl.offsetLeft

      if (offsetLeft + innerWidth > wrapperWidth) {
        submenuEl.style.left = 'auto'
        submenuEl.style.right = '2px'
      }

      if (offsetLeft < 0) {
        submenuEl.style.left = `${2 - elementOffset}px`
      }

      submenuEl.style.visibility = ''
    }
  },

  template: `
    <div class="buttons-preview-container">
      <p v-if="isEmpty" class="buttons-preview-empty">当前还没有可预览的菜单</p>
      <template v-else>
        <div
          class="buttons-preview-screen"
          aria-hidden="true"
          @click="onScreenClick"
        ></div>
        <div class="bottom-bar">
          <div class="preview-home">
            <a href="##" @click.prevent.stop>
              <i class="slp-home"></i>
            </a>
          </div>
          <div class="preview-menus">
            <div
              v-for="(button, index) in buttons"
              :key="button._uid || index"
              :ref="'menuItem' + index"
              class="preview-menu-item"
              :class="{
                'with-submenu': hasSubmenu(button),
                'is-open': activeRootIndex === index
              }"
              @click.stop="onMenuItemClick(index, $event)"
            >
              <a href="##" @click.prevent>
                <i v-if="hasSubmenu(button)" class="menu-icon" aria-hidden="true"></i>
                <span>{{ button.name }}</span>
              </a>
              <div
                v-if="hasSubmenu(button)"
                :ref="'submenu' + index"
                class="submenu-container"
                :class="{ open: activeRootIndex === index }"
              >
                <ul>
                  <li v-for="(sub, subIndex) in button.sub_button" :key="sub._uid || subIndex">
                    <a href="##" @click.prevent>{{ sub.name }}</a>
                  </li>
                </ul>
                <span class="menu-caret"><span></span></span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  `
}
